import { Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';

const DownloadStartedModal = ({ open, onClose }: any) => {

    // Close modal automatically after 3 seconds
    useEffect(() => {
        setTimeout(() => {
            onClose();
        }, 3000);
    }, []);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
        Your download has started and will be completed soon.
            </DialogContent>
        </Dialog>
    )
}

export default DownloadStartedModal;